import { render } from "./rpt_compra_venta_proveedor.vue?vue&type=template&id=884294da"
import script from "./rpt_compra_venta_proveedor.vue?vue&type=script&lang=js"
export * from "./rpt_compra_venta_proveedor.vue?vue&type=script&lang=js"

import "./rpt_compra_venta_proveedor.vue?vue&type=style&index=0&id=884294da&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__